import { render, staticRenderFns } from "./CompanyList.vue?vue&type=template&id=9fc2f1d6&scoped=true&lang=pug"
import script from "./CompanyList.vue?vue&type=script&lang=ts"
export * from "./CompanyList.vue?vue&type=script&lang=ts"
import style0 from "./CompanyList.vue?vue&type=style&index=0&id=9fc2f1d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fc2f1d6",
  null
  
)

export default component.exports